import 'style/style.scss';
import Navigation from 'components/Navigation';
import MainCarousel from 'components/MainCarousel';
import ShowPassword from 'components/ShowPassword';
import ProductsTabs from 'components/ProductsTabs';
import NavCarousel from 'components/NavCarousel';
import CardCarousel from 'components/CardCarousel';
import ProductsCarousel from 'components/ProductsCarousel';
import Faq from 'components/Faq';
import Authors from "./components/Authors";
import Registration from "./components/Registration";
import Location from "./components/Location";
import LanguageSwitcher from "./components/LanguageSwitcher";
import ProductsList from "./components/ProductsList";
import IncDecInput from 'components/IncDecInput';
import QuickSearch from 'components/QuickSearch';
import BillingForm from 'components/BillingForm';
import ShippingForm from 'components/ShippingForm';
import LazyLoad from 'components/LazyLoad';
import CheckoutForm from 'components/CheckoutForm';

$(document).ready(() => {
    const navigation = new Navigation();
    navigation.init();
    const mainCarousel = new MainCarousel();
    mainCarousel.init();
    const showPassword = new ShowPassword();
    showPassword.init();
    const productsTabs = new ProductsTabs();
    productsTabs.init();
    const navCarousel = new NavCarousel();
    navCarousel.init();
    const cardCarousel = new CardCarousel();
    cardCarousel.init();
    const productsCarousel = new ProductsCarousel();
    productsCarousel.init();
    const faq = new Faq();
    faq.init();
    const authors = new Authors();
    authors.init();
    const registration = new Registration();
    registration.init();
    const location = new Location();
    location.init();
    const languageSwitcher = new LanguageSwitcher();
    languageSwitcher.init();
    const productsList = new ProductsList();
    productsList.init();
    let incDecInput = new IncDecInput();
    incDecInput.init();
    let quickSearch = new QuickSearch();
    quickSearch.init();
    let billingForm = new BillingForm();
    billingForm.init();
    let shippingForm = new ShippingForm();
    shippingForm.init();
    let checkoutForm = new CheckoutForm();
    checkoutForm.init();

    let lazy = new LazyLoad();
    lazy.init();

    $('.js-mob-search').on('click', function () {
        $('.js-header-search').toggleClass('is-active');
    });

    if($(".js-modal-video").length){
        $(".js-modal-video").modalVideo({
            channel: 'vimeo'
        });
    }

    // jQuery( document.body ).on(name['update_cart'], function () {
    //     location.reload( true );
    // } );

    $("form[name='update_cart']").on('click', function (e) {
        e.preventDefault();
        form.submit();
    });

    $(".woof_checkbox_term").parent().has('ul').find('input:first').attr('disabled','disabled');
});


// WEBPACK FOOTER //
// ./static/js/index.js